import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Box, Spinner, Text, useToast } from "@chakra-ui/react";
import DealEditor from "./DealEditor";
import Navbar from "./Navbar";
import WatermarkBackground from "./components/WatermarkBackground";
import { getDeal, getProductByCode } from "./services/MrcaiAPI";

const DealEditorPage = () => {

  const { productCode, dealId } = useParams();
  const [deal, setDeal] = useState(null);
  const [product, setProduct] = useState(null);
  const [dealLoaded, setDealLoaded] = useState(false);
  const [productLoaded, setProductLoaded] = useState(false);
  const toast = useToast();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchDeal = async () => {
      try {
        setDeal(await getDeal(dealId));
      } catch (err) {
        toast({ title: "Failed to load deal", description: err.message, status: "error" });
      } finally {
        setDealLoaded(true);
      }
    };

    const fetchProduct = async () => {
      try {
        setProduct(await getProductByCode(productCode));
      } catch (err) {
        toast({ title: "Failed to load product", description: err.message, status: "error" });
      } finally {
        setProductLoaded(true);
      }
    };

    fetchDeal();
    fetchProduct();
  }, [productCode, dealId]);

  if (!dealLoaded || !productLoaded) return <Spinner size="xl" />;

  return (
    <Box position="relative" width="100%" minHeight="100vh">
      <WatermarkBackground />
      <Navbar />

        <DealEditor
          productCode={productCode}
          deal={deal}
          productInstance={product}
          productTemplate={null}
        />

    </Box>
  );
};

export default DealEditorPage;
